import BaseStorage from "./BaseStorage";

/**
 * Storage service for user data.
 *
 * Always uses localStorage so the OAuth session is shared across tabs and
 * across browser/standalone (installed PWA) contexts. sessionStorage is scoped
 * to a single browsing context, so a deep link opened in a new tab/window (or
 * the standalone PWA when login happened in the browser) would start with no
 * tokens and wrongly show the login screen even though the user is
 * authenticated.
 *
 * Implements most Storage methods plus some utility functions.
 */
class AuthStorage extends BaseStorage {

    // All names like 'user.xxx'
    static keyPrefix = 'auth';

    /**
     * Gets storage object.
     */
    static storage(): Storage {
      return window.localStorage;
    }

}

export default AuthStorage;
